import React, { Component } from 'react';
import { withStyles } from 'material-ui/styles';

import List, { ListItem, ListItemIcon, ListItemText } from 'material-ui/List';
import { MenuList, MenuItem } from 'material-ui/Menu';

import Reboot from 'material-ui/Reboot';
import 'typeface-roboto';
import Table, { TableBody, TableCell, TableHead, TableRow } from 'material-ui/Table';

import TextField from 'material-ui/TextField';
import {ajaxPost} from '../ajax';
import Button from 'material-ui/Button';
import Typography from 'material-ui/Typography';
import { CircularProgress } from 'material-ui/Progress';
import green from 'material-ui/colors/green';
import Paper from 'material-ui/Paper';
import CardContent from 'material-ui/Card/CardContent';
import Card from 'material-ui/Card';

import LogoutIcon from 'material-ui-icons/ExitToApp'
import IconButton from 'material-ui/IconButton';
import Tooltip from 'material-ui/Tooltip';


var moment = require('moment');

const styles = theme => ({
  textField: {
    marginLeft: theme.spacing.unit,
    marginRight: theme.spacing.unit,
    marginTop: 15,
    width: 200,
},
table: {
  marginTop:20,
},
main:
{
  margin:10
},
fabProgress: {
  color: green[500],
  position: 'absolute',
  top: '50%',
  left: '50%',
  marginTop: -15,
  marginLeft: -15,
    },
    wrapper: {
      margin: theme.spacing.unit,
      position: 'relative',
      display:'inline-flex',
    },
    select:
    {
        width:500,
    },
    selectLabel:
    {
      fontSize:"10.5pt",
      marginBottom:5,
    },
    calendar:
    {
        width:100,
        borderRight:"1px solid lightgray",
        textAlign:"right",
        padding:"0px 5px 20px 0px",
        margin:10,
        verticalAlign:'top',
      },
      divDate:
      {
          fontSize:"24pt",
          fontWeight:"bold",
          color:"navy",
          margin:5
      },
      divDay:
      {

      },
      tdMessage:{
          borderBottom:"1px dotted lightgray",
          fontSize:"10pt",
          paddingBottom:10,
      },
      tdEntries:
      {
          width:100,
          paddingTop:10,
          fontWeight:"bold",
      },
      divContents:
      {
        marginLeft:20,
      },
  paper:
  {
    padding:10,     
    marginTop:10,
  },
    

});

class UserTimeEntries extends Component {

    state = 
        {
            StartDate:moment().format('YYYY-MM-DD'),
            EndDate: moment().format('YYYY-MM-DD'),
            loading:true,
            list:[],
        };

  componentDidMount = () =>
  {
    var dt = moment().format("YYYY-MM-DD");
    setTimeout(()=>this.listLogs(dt,dt));
  }

  listLogs = (dtStart,dtEnd) =>
  {

    this.setState({loading:true});
    ajaxPost({
      url: '/DeviceLogAPI/ListDeviceLogsAIMS',
      data: 
      {
        StartDate:dtStart,
        EndDate:dtEnd,
        DeviceIDs:[],
        EmployeeIDs:[global.employeeID],
      },
      onError: ()=>{},
      onSuccess: data => {
        var list = [];
        var dt = moment(dtEnd);
        while( dt.isSameOrAfter(dtStart))
        {

          list.push(
            {
              Date:dt.format(),
              Entries:data.filter(x=>dt.isSame(x.RecordDate)),
            }
          )
          dt.subtract(1,"d");
        }
        this.setState({list:list});
        this.setState({loading:false});
      },
      finally: ()=>
      {
          this.setState({loading:false});
          
      }
  }
  )
  }

  onChangeStartDate = (evt) =>
  {
      var str = evt.target.value;
      var dtEnd = this.state.EndDate;

      this.setState({StartDate:str});
      if( moment(str)>moment(this.state.EndDate))
      {
        this.setState({EndDate:str});
        dtEnd = str;
      }
      this.listLogs(str, dtEnd);
  }

  onChangeEndDate = (evt) =>
  {
    var str = evt.target.value;
    var dtStart = this.state.StartDate;

    this.setState({EndDate:str});
    if( moment(str)<moment(this.state.StartDate))
    {
      this.setState({StartDate:str});
      dtStart = str;
    }

    this.listLogs(dtStart,str);
  }

  
render() {
    const { classes } = this.props;
    return (
          <div >
          <TextField className={classes.textField}
              value={this.state.StartDate}
              label="Start Date"
              type="date"
              onChange={this.onChangeStartDate.bind(this)} />
          <TextField className={classes.textField}
              value={this.state.EndDate}
              type="date"
              label="End Date"
              onChange={this.onChangeEndDate.bind(this)} />

          
          {this.state.loading  ? <CircularProgress /> :
        <Paper className={classes.paper}>
          <Typography>
        <table className={classes.table}>
        <tbody>
          {this.state.list.map(n => {
            return [
              <tr>
                <td className={classes.calendar}>
                <div className={classes.divDay}>{moment(n.Date).format("dddd")}</div>
                <div className={classes.divDay}>{moment(n.Date).format("MMM")}</div>
                <div className={classes.divDate}>{moment(n.Date).format("DD")}</div>
                </td>
                <td>
                  <div className={classes.divContents}>
                    <table>
                      {n.Entries.map( e =>
                      [
                        <tr >
                          <td className={classes.tdEntries}>{e.LogType}</td>
                          <td className={classes.tdEntries}>{e.RecordTime}</td>
                          <td className={classes.tdEntries}>{e.DeviceName}</td>
                          <td>&nbsp;</td>
                        </tr>,
                        <tr>
                          <td className={classes.tdMessage} colspan={4}>{e.Message}</td>
                        </tr>
                      ])
                      }
                    </table>
                  </div>
                </td>
              </tr>,
              <tr style={{"height":"20px"}}></tr>
            ]
          })}
        </tbody>
      </table>
      </Typography>
      </Paper>
          }
      </div>
    );
  }
}

export default withStyles(styles)(UserTimeEntries);



// WEBPACK FOOTER //
// ./src/user/UserTimeEntries.js